// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"696":"3c594e35","788":"43a5996d"}[chunkId] + ".chunk.js";
};